import axiosInstance from "../config/axios.config";

/*
 * Purchase Returns - stock sent BACK to a vendor (damaged, expired, wrong
 * item). A draft has no stock impact; completing it decreases stock and is
 * irreversible.
 *
 * Facility scoping comes from the `facility` header axios.config.js attaches.
 */

export const getPharmacyPurchaseReturnsApi = (params) =>
  axiosInstance.get(`pharmacy/purchase-returns/?${params}`);

export const getPharmacyPurchaseReturnApi = (id) =>
  axiosInstance.get(`pharmacy/purchase-returns/${id}/`);

/**
 * Creates the return and its line items in one call; opens as "draft".
 * Every item's batch must belong to the acting facility.
 */
export const createPharmacyPurchaseReturnApi = (payload) =>
  axiosInstance.post("pharmacy/purchase-returns/", payload);

/** Top-level fields only, and only while still a draft - items are not editable. */
export const updatePharmacyPurchaseReturnApi = (id, payload) =>
  axiosInstance.patch(`pharmacy/purchase-returns/${id}/`, payload);

export const deletePharmacyPurchaseReturnApi = (id) =>
  axiosInstance.delete(`pharmacy/purchase-returns/${id}/`);

/** Decreases stock for every line's batch. Fails if any qty exceeds stock. */
export const completePharmacyPurchaseReturnApi = (id) =>
  axiosInstance.post(`pharmacy/purchase-returns/${id}/complete/`);

/**
 * The whole return at once - header and lines - replacing what is on the
 * server. Takes the same payload the return was created with, and is refused
 * once the return has been completed.
 */
export const editPharmacyPurchaseReturnApi = (id, payload) =>
  axiosInstance.put(`pharmacy/purchase-returns/${id}/edit/`, payload);

/** Only permitted while the return is still a draft. */
export const cancelPharmacyPurchaseReturnApi = (id) =>
  axiosInstance.post(`pharmacy/purchase-returns/${id}/cancel/`);

/**
 * Batches worth sending back to a vendor - stock from that vendor expiring on
 * or before `expires_by` (YYYY-MM-DD) - used to seed a new return instead of
 * hunting for the batches by hand.
 */
export const getPharmacyPurchaseReturnSuggestionsApi = (params) =>
  axiosInstance.get(`pharmacy/purchase-returns/suggestions/?${params}`);

/*
 * Editing one line of a return the server already holds.
 *
 * On a completed return the server moves stock by the difference - returning
 * more takes it out, where it is there to take; returning less puts it back.
 * Changing the batch replaces the line, so its id changes, and a return must
 * keep at least one line.
 */
export const addPharmacyPurchaseReturnEditItemApi = (returnId, payload) => {
  return axiosInstance.post(`pharmacy/purchase-returns/${returnId}/edit/items/`, payload);
};

export const updatePharmacyPurchaseReturnEditItemApi = (returnId, itemId, payload) => {
  return axiosInstance.patch(
    `pharmacy/purchase-returns/${returnId}/edit/items/${itemId}/`,
    payload
  );
};

export const removePharmacyPurchaseReturnEditItemApi = (returnId, itemId, payload) => {
  return axiosInstance.delete(
    `pharmacy/purchase-returns/${returnId}/edit/items/${itemId}/`,
    payload ? { data: payload } : undefined
  );
};
